const normalizeTask = task => {
  if (!task) {
    return task;
  }

  return {
    ...task,
    taskId: task.taskId ?? task.id ?? null,
    name: task.name ?? '',
    taskType: task.taskType ?? null,
    lastModified: task.lastModified ?? null,
    targetType: task.targetType ?? null,
    assignedUserId: task.assignedUserId ?? null,
  };
};

const normalizeTaskList = data => (Array.isArray(data) ? data.map(normalizeTask) : []);

// The Loans contact-task create body mirrors the subcompany body, swapping
// subCompanyId for contactId and wrapping requests in the same array envelope.
const buildCreateBody = ({
  contactId,
  assignedUserId,
  taskTypeId,
  name,
  description,
  availableForAssignees,
}) => ({
  contactId,
  assignedUserId,
  availableForAssignees: availableForAssignees ?? false,
  requests: [
    {
      taskTypeId,
      name,
      description,
      metadata: null,
    },
  ],
});

export class ContactTaskApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // List — calls the shared Loans tasks engine with contactId + contactTasksOnly filter.
  async getContactTasks({ contactId, signal }) {
    const response = await this.#http.get('/api/tasks', {
      params: {
        contactId,
        contactTasksOnly: true,
      },
      signal,
    });

    return { ...response, data: normalizeTaskList(response.data) };
  }

  // Create — posts to the Loans contact-task endpoint.
  async createContactTask(fields) {
    const response = await this.#http.post('/api/tasks/contact', buildCreateBody(fields));

    const created = Array.isArray(response.data) ? response.data[0] : response.data;

    return { ...response, data: normalizeTask(created) };
  }

  // Complete — marks a task done via the shared Loans task engine.
  async completeContactTask({ taskId }) {
    const response = await this.#http.post(`/api/tasks/${taskId}/complete`);

    return { ...response, data: normalizeTask(response.data) };
  }

  // Delete — removes a task via the shared Loans task engine.
  async deleteContactTask({ taskId }) {
    return this.#http.delete(`/api/tasks/${taskId}`);
  }
}
